// Mirrors the API's join window (onicares-api video-consultation/join-window.ts); the API is the authority
// and refuses a token outside it, this only decides when the Join button is worth showing.
const OPENS_BEFORE_START_MIN = 10;
const CLOSES_AFTER_END_MIN = 30;

const CLOSED_STATUSES = ['CANCELLED', 'COMPLETED', 'NO_SHOW'];

export const canJoinVideoCall = (appointment, slot, now = Date.now()) => {
  if (appointment?.mode !== 'VIDEO_CALL' || !appointment.checkedInAt) return false;
  if (CLOSED_STATUSES.includes(appointment.status)) return false;
  const opensAt = new Date(slot?.startDateTime).getTime() - OPENS_BEFORE_START_MIN * 60000;
  const closesAt = new Date(slot?.endDateTime).getTime() + CLOSES_AFTER_END_MIN * 60000;
  return now >= opensAt && now <= closesAt;
};

// A denied camera or microphone is the common failure; anything else shows the SDK's own message.
export const sdkErrorText = (e) =>
  /PERMISSION|NotAllowed|denied/i.test(`${e?.code} ${e?.name} ${e?.message}`)
    ? 'Allow camera and microphone access in the browser, then try again.'
    : e?.message || 'Could not join the call.';

// What to tell the provider for each refusal the API can give on the join-token / provider-joined calls.
export const VIDEO_CALL_ERRORS = {
  OUTSIDE_JOIN_WINDOW: 'The call can only be joined shortly around the appointment time.',
  NOT_CHECKED_IN: 'Check the patient in before joining.',
  ROOM_CLOSED: 'This call has ended.',
  CALL_ROOM_NOT_FOUND: 'This appointment has no active video call.',
  CALL_ROOM_FORBIDDEN: 'You are not the provider for this appointment.',
  CONSULTATION_START_FORBIDDEN: "You don't have permission to start this consultation.",
  TELEMEDICINE_NOT_ENABLED: 'Video consultations are not enabled for this hospital.',
  CALL_PROVIDER_NOT_CONFIGURED: 'Video calls are not available right now.',
};

// The room's recordingStatus when the recording could not start. IMPORT_FAILED is not here: it only happens
// after the call has ended, and a retry cannot help it.
export const RECORDING_FAILED = 'RECORDING_FAILED';
export const RECORDING_POLL_MS = 5000;
